import { render, staticRenderFns } from "./SpinWin.vue?vue&type=template&id=2f595a2d&scoped=true&"
import script from "./SpinWin.vue?vue&type=script&lang=js&"
export * from "./SpinWin.vue?vue&type=script&lang=js&"
import style0 from "./SpinWin.vue?vue&type=style&index=0&id=2f595a2d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f595a2d",
  null
  
)

export default component.exports